import { Component, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { MobilewidgetService } from '../../services/widget/mobilewidget.service';
import { DragulaService } from 'ng2-dragula';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { WidgetTemplate } from '../../models/widget/widget-template.model';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { DynamicPage } from '../../models/widget/dynamic-page.model';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { DisplayCategory } from '../../models/category/DisplayCategory.model';
import { CategoryService } from '../../services/category/category.service';
import { PageWidget } from '../../models/widget/page-widget.model';
import { WidgetContent } from '../../models/widget/widget-content.model';
import { Brand } from '../../models/brand/brand-model';
import { BrandService } from '../../services/brand/brand.service';
import { Sales } from '../../models/sales/sales.model';
import { Product } from '../../models/products/product.model';
import { ProductService } from '../../services/product/product.service';
import { Customer } from '../../models/customer/customer-model';

@Component({
    selector: 'app-create-mobile-page-widget',
    templateUrl: './create-mobile-page-widget.component.html',
    styleUrls: ['./create-mobile-page-widget.component.css']
})
/** create-mobile-page-widget component*/
export class CreateMobilePageWidgetComponent {
  public widgetTemplateList: WidgetTemplate[];
  public dynamicPageList: DynamicPage[];
  public pageWidget = new PageWidget();
  public widgetContentList: WidgetContent[] = [];
  public widgetContent = new WidgetContent();
  public pageWidgetList: PageWidget[];
  public productWidgetContentList: WidgetContent[] = [];
  public CategoryProducts: Product[] = [];
  public vendors: Customer[];
  public vendorsList: Customer[] = [];
  public selectedVendorIds: any[] = [];
  productWidgetType: string;
  productWidgetTypes: any[];
  public savedPageWidgetId: number;
  productWidgetTypeId: number;
  saleList: Sales[];
  saleId: number;
  productWidgetEnum = ProductWidgetTypes;

  modalRef: BsModalRef;
  config = {
    animated: true
  };
  customDPage: string;
  currentWidgetTemplateID: number;
  bannerfd = new FormData();
  bannerImageData: string;
  bannerImageRedirectUrl: string;
  selectedBannerImage: string;
  fileToUpload: File;
  tempFileToUpload: File;
  isTextOverImage: boolean;
  public htmlContent: any;
  configuration = {
    uiColor: '#ffffff',
    toolbarGroups: [{ name: 'clipboard', groups: ['clipboard', 'undo'] },
    { name: 'editing', groups: ['find', 'selection', 'spellchecker'] },
    { name: 'links' }, { name: 'insert' },
    { name: 'document', groups: ['mode', 'document', 'doctools'] },
    { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
    { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align'] },
    { name: 'styles' },
    { name: 'colors' }],
    resize_enabled: false,
    removePlugins: 'save',
    extraPlugins: 'smiley,justify,indentblock,colordialog',
    colorButton_foreStyle: {
      element: 'font',
      attributes: { 'color': '#(color)' }
    },
    height: 188,
    removeDialogTabs: '',
    removeButtons: '',
    format_tags: 'p;h1;h2;h3;pre;div'
  }
  // #region Category Widget Variables

  public allCategoryList: DisplayCategory[] = [];
  public parentCategoryList: DisplayCategory[];
  public subCategoryList: DisplayCategory[] = [];
  public thumbnailCategoryList: DisplayCategory[] = [];

  // #region Popular Category
  public selectedPopualarCategoryIds: any[] = [];
  public popularCategoryList: DisplayCategory[] = [];
  public displayPopularCategoryList: DisplayCategory[] = [];
  widgetContentTypePopularCatId: number;
  isMax9Categories: boolean;
  popularCategoryThumbnailIds: string;

  // #region Top Category
  public selectedTopCategoryIds: any[] = [];
  public topCategoryList: DisplayCategory[] = [];
  topCategoryThumbnailIds: string;

  // #region Brand
  public popularBrands: Brand[] = [];
  public selectedBrandIds: any[] = [];
  public Brands: Brand[];
  //#region Brand multi select func.
  public selectedCategoryIds: any[] = [];
  public selectedCategoryId: string;
  isMax1FirstLevelCategory: boolean;
    // #Region Flash Sale Banner
  minDate: Date;
  maxDate: Date;
  endMaxDate: Date;
  saleStartDate: string;
  saleEndDate: string;
  flashSaleBannerfd = new FormData();
   flashSaleBannerImageData: string;
  flashSaleBannerImageRedirectUrl: string;
  selectedFlashSaleBannerImage: string;
  saleDateRequiredMsg: string;
  // #End Region Flash Sale Banner

  // #Region Send Me App
  selectedILoveAppBannerImage: string;
  // #End Region Send Me App

  subCategoryDropdownSettings = {};
  dropdownSettings = {};
  TopVendorDropdownSettings = {};
  ngOnInit() {
    this.subCategoryDropdownSettings = {
      singleSelection: false,
      idField: 'categoryID',
      textField: 'categoryName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'brandID',
      textField: 'brandName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    this.TopVendorDropdownSettings = {
      singleSelection: false,
      idField: 'customerID',
      textField: 'shopeName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
  }
  onCategorySelect(item: any) {

  }
  onSelectAll(items: any) {


  }
  onItemSelect(item: any) {


  }
  // #endregion Multi select func.
    /** create-mobile-page-widget ctor */
  constructor(private readonly widgetService: MobilewidgetService,
    private dragulaService: DragulaService,
    private modalService: BsModalService,
    private readonly categoryService: CategoryService,
    private readonly brandsService: BrandService,
    private readonly productService: ProductService,
    private readonly toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("mobilepageWidget").subscribe(
      data => {
        if (data != null) {
          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          if (create.length > 0) {
            this.toastr.setRootViewContainerRef(vcr);
            this.productWidgetTypes = this.enumSelector(this.productWidgetEnum);
            this.GetWidgetTemplates();
            this.GetDynamicPages();
            this.GetCategoryList();
            this.GetAllBrands();
            this.GetCategoryAndCompanySales();
            this.GetBestVendors();
            this.customDPage = "";
            this.isMax9Categories = true;
            this.isMax1FirstLevelCategory = true;
            this.isTextOverImage = false;
            try {
              this.dragulaService.destroy("VAMPIRES");
            } catch (e) {
            }
            this.dragulaService.createGroup("VAMPIRES", {

            });
            this.dragulaService.dropModel("VAMPIRES").subscribe(args => {
            });
          }
          else {
            this.router.navigate(["/mobile-page-widget-list"]);
          }
        }
        else {
          this.router.navigate(["/mobile-page-widget-list"]);
        }
      }
    )
    this.minDate = new Date();
    this.maxDate = new Date();
    this.endMaxDate = new Date();
    this.minDate.setDate(this.minDate.getDate());
  }
  //mobilepageWidget
  // #region Get Methods => Prerequisite data Load
  GetWidgetTemplates() {
    this.widgetService.GetWidgetTemplates().subscribe(
      data => {
        this.widgetTemplateList = data;

      }
    )
  }

  GetDynamicPages() {
    this.widgetService.GetDynamicPages().subscribe(
      data => {
        this.dynamicPageList = data;
      }
    )
  }
  GetAllBrands() {
    this.brandsService.getBrand().subscribe(
      data => {
        this.Brands = data;
      }

    )
  }

  GetCategoryList() {
    this.categoryService.GetAllDisplayCategoryList().subscribe(
      data => {
        this.allCategoryList = data;
        this.subCategoryList = this.allCategoryList.filter(s => s.isParent == false);
        //let pc = this.allCategoryList.filter(s => s.parentCategoryID == 0);
        this.parentCategoryList = this.allCategoryList.filter(s => s.parentCategoryID == 0);
        for (var i = 0; i < this.parentCategoryList.length; i++) {
          this.displayPopularCategoryList.push(this.parentCategoryList[i]);
          let category = this.allCategoryList.filter(s => s.isParent == true && s.parentCategoryID == this.parentCategoryList[i].categoryID);
          for (var j = 0; j < category.length; j++) {
            category[j].categoryName = this.parentCategoryList[i].categoryName + " => " + category[j].categoryName;
            this.displayPopularCategoryList.push(category[j]);
            let subCategory = this.allCategoryList.filter(s => s.parentCategoryID == category[j].categoryID);
            for (var k = 0; k < subCategory.length; k++) {
              subCategory[k].categoryName = category[j].categoryName + " => " + subCategory[k].categoryName;
              this.displayPopularCategoryList.push(subCategory[k]);
            }
          }
        }
      }
    )
  }

  GetBestVendors() {
    this.widgetService.GetBestVendors().subscribe(
      data => {
        this.vendors = data;
      });
  }
    // #End region Get Methods => Prerequisite data Load


  // #region Widget Template Events

  toggleClass(event: any) {

    const hasClass = event.srcElement.classList.contains('check');
    var element = document.getElementsByClassName("img-check");
    for (var i = 0; i < element.length; i++) {
      element[i].classList.remove('check');
    }
    if (hasClass) {
      event.srcElement.classList.remove('check');
      // setTimeout(this.widgetTemplateID = 0, 1000);
    } else {
      event.srcElement.classList.add('check');
    }
  }
  onCheckboxChange(widgetTemplateId: number) {
    //this.pageWidget.widgetTemplateID = widgetTemplateId;
    this.currentWidgetTemplateID = widgetTemplateId;
    //this.LaodSavedWidgets(false);
    this.WidgetContentInitialization();
    try {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    } catch (e) {
      window.scrollTo(0, 0);
    }

    //this.GetAllWidgetContentsOfProducts(widgetTemplateId);
  }

  // #endregion
  // #Region For Popular Category
  OpenCategoryModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config);
  }
  AddPopularCategory() {
    if (this.selectedPopualarCategoryIds.length > 9) {
      this.isMax9Categories = false;
    } else {
      this.isMax9Categories = true;
      this.popularCategoryList = [];
      for (var i = 0; i < this.selectedPopualarCategoryIds.length; i++) {
        var selectedCategory = this.allCategoryList.find(s => s.categoryID == this.selectedPopualarCategoryIds[i].categoryID);
        if (selectedCategory != null) {
          this.popularCategoryList.push(selectedCategory);
        }
      }
      this.modalRef.hide();
    }
  }
  //# EndRegion For Popular Category

  // #Region For Top Category
  AddTopCategory() {

      this.topCategoryList = [];
      for (var i = 0; i < this.selectedTopCategoryIds.length; i++) {
        var selectedCategory = this.allCategoryList.find(s => s.categoryID == this.selectedTopCategoryIds[i].categoryID);
        if (selectedCategory != null) {
          this.topCategoryList.push(selectedCategory);
        }
      }
      this.modalRef.hide();
  }
  //# EndRegion For Top Category

  // #region Add Brands to Array List
  openBrandModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config);
  }
  decline(): void {
    this.bannerfd = new FormData();
    this.modalRef.hide();
  }
  AddBrands() {
    this.popularBrands = [];
    for (var i = 0; i < this.selectedBrandIds.length; i++) {
      var selectedbrand = this.Brands.find(s => s.brandID == this.selectedBrandIds[i].brandID);
      if (selectedbrand != null) {
        this.popularBrands.push(selectedbrand);
        }
      }
      this.modalRef.hide();
  }
  // #End Region Add Brands to Array List

  // #Region Top Vendor
  AddTopVendor() {
    this.vendorsList = [];
    for (var i = 0; i < this.selectedVendorIds.length; i++) {
      var selectedVendor = this.vendors.find(s => s.customerID == this.selectedVendorIds[i].customerID);
      if (selectedVendor != null) {
        this.vendorsList.push(selectedVendor);
      }
    }
    this.modalRef.hide();
  }
  // #EndRegion Top Vendor

  // #Region Banner
  uploadBannerImage(file: FileList) {
    this.fileToUpload = file.item(0);
    this.tempFileToUpload = file.item(0);
    this.bannerfd.append(WidgetContentTypes.Banner.toString(), this.fileToUpload);
    //var reader = new FileReader();
    //reader.onload = (event: any) => {
    //  this.selectedCategoryImage = event.target.result;
    //}
    //reader.readAsDataURL(this.fileToUpload);
  }
  AddBannerImage() {
    if (this.tempFileToUpload != null) {
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.selectedBannerImage = event.target.result;
      }
      reader.readAsDataURL(this.tempFileToUpload);
      this.tempFileToUpload = null;
    }
    //Banner Hero img data structure => url,path
    this.bannerImageData = this.bannerImageRedirectUrl +
      "," +
      WidgetImageContents.DummyPath.toString();
   
    if (this.isTextOverImage) {
      this.htmlContent = this.htmlContent.replace("~", " ").replace("|","");
    } else {
      this.htmlContent = "";
    }
    this.modalRef.hide();
  }
  // #EndRegion Banner

  // #Region FirstLevel Category

  AddFirstLevelCategory() {
    if (this.selectedCategoryIds.length > 1) {
      this.isMax1FirstLevelCategory = false;
    } else {
      this.isMax1FirstLevelCategory = true;
      this.selectedCategoryId = this.selectedCategoryIds[0].categoryID;
      // getting products related to category
      this.productService.FetchProductByCategoryID(this.selectedCategoryIds[0].categoryID).subscribe(
        data => {
          this.CategoryProducts = data;
        }
      )
      this.modalRef.hide();
    }
  }
  // #EndRegion FirstLevel Category

  // #Region Product widgets
  GetCategoryAndCompanySales() {
    this.categoryService.GetMobileSales().subscribe(
      data => {
        this.saleList = data;
      }
    )
  }
  ShowProductWidget() {
    // call database method to check saved Widget Contents
    this.widgetService.GetAllWidgetContentsOfProducts(this.currentWidgetTemplateID).subscribe(data => {
      this.productWidgetContentList = data;
      if (this.productWidgetType != "") {
        var enumProductWidgetType = this.productWidgetTypes.find(s => s.value == this.productWidgetType);
        var existingProductWidgetType = this.productWidgetContentList.find(s => s.pageWidgetID == this.savedPageWidgetId && s.type == enumProductWidgetType.title);
        if (existingProductWidgetType != null) {
          this.productWidgetTypeId = existingProductWidgetType.widgetContentID;
          this.pageWidget.sortOrder = parseInt(this.ColonSpliter(existingProductWidgetType.data)[1]);
        } else {
          this.productWidgetTypeId = 0;
        }
      } else {
        this.productWidgetTypeId = 0;
      }

    });
  }
  // #EndRegion Product widget

    // #Region Flash Sale Banner
  
  uploadFlashSaleBannerImage(file: FileList) {
    this.fileToUpload = file.item(0);
    this.tempFileToUpload = file.item(0);
    this.flashSaleBannerfd.append(WidgetContentTypes.FlashSaleBanner.toString(), this.fileToUpload);
  }
  AddFlashSaleBannerImage() {
    if (this.tempFileToUpload != null) {
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.selectedFlashSaleBannerImage= event.target.result;
      }
      reader.readAsDataURL(this.tempFileToUpload);
      this.tempFileToUpload = null;
    }
    if (this.saleStartDate != null && this.saleEndDate != null) {
      this.saleDateRequiredMsg = "";
      //Flash sale Banner img data structure => url,path|StartDate,EndDate
      this.flashSaleBannerImageData = this.flashSaleBannerImageRedirectUrl +
        "," +
        WidgetImageContents.DummyPath.toString();
      this.modalRef.hide();
    } else {
      this.saleDateRequiredMsg = "Sale Start and End Date is Required";
    }
  }

  selectStartDate(e) {
    if (e != null) {
      this.saleStartDate = e;
      this.maxDate = e;
      this.endMaxDate = new Date(this.maxDate);
    }
  }
  selectEndDate(e) {
    if (e != null) {
      this.saleEndDate = e;
    }
  }

    // #End Region Flash Sale Banner
  // #Region Send Me App
  AddILoveAppBannerImage() {
    if (this.tempFileToUpload != null) {
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.selectedILoveAppBannerImage = event.target.result;
      }
      reader.readAsDataURL(this.tempFileToUpload);
      this.tempFileToUpload = null;
    }
    this.modalRef.hide();
  }
  // #EndRegion Send Me App
  SaveWidget() {
    // For Popular Category
   if (this.currentWidgetTemplateID == 9) {
      // popular category
      this.widgetContent = new WidgetContent();
      this.widgetContentList = [];
      //this.widgetContent.widgetContentID = this.widgetContentTypePopularCatId;
     this.widgetContent.type = WidgetContentTypes.PopularCategory.toString();
      this.widgetContent.data = "";
      //data structure for saving category Thumbnail => commaSepratedIds
      var strCategoryIds = "";
      for (var i = 0; i < this.selectedPopualarCategoryIds.length; i++) {
        strCategoryIds += "," + this.selectedPopualarCategoryIds[i].categoryID;
      }
      if (strCategoryIds != "") {
        strCategoryIds = strCategoryIds.substring(1); // remove first comma ','
        this.widgetContent.data = strCategoryIds;
      }
      this.widgetContentList.push(this.widgetContent);
      // saving here

      this.pageWidget.dynamicPageID = parseInt(this.customDPage);
      this.pageWidget.widgetTemplateID = this.currentWidgetTemplateID;
      this.pageWidget.widgetContentList = this.widgetContentList;

      this.widgetService.SaveWidget(this.pageWidget).subscribe(result => {

        this.pageWidget = new PageWidget();
        this.widgetContentList = [];
        this.router.navigate(["/mobile-page-widget-list"]);
      });
   } else  // For Popular Brands
     if (this.currentWidgetTemplateID == 10) {
     // popular category
     this.widgetContent = new WidgetContent();
     this.widgetContentList = [];
       this.widgetContent.type = WidgetContentTypes.PopularBrands.toString();
     this.widgetContent.data = "";
     //data structure for saving Brands=> commaSepratedIds
       var strBrandIds = "";
       for (var i = 0; i < this.selectedBrandIds.length; i++) {
         strBrandIds += "," + this.selectedBrandIds[i].brandID;
     }
       if (strBrandIds != "") {
         strBrandIds = strBrandIds.substring(1); // remove first comma ','
         this.widgetContent.data = strBrandIds;
     }
     this.widgetContentList.push(this.widgetContent);
     // saving here

     this.pageWidget.dynamicPageID = parseInt(this.customDPage);
     this.pageWidget.widgetTemplateID = this.currentWidgetTemplateID;
     this.pageWidget.widgetContentList = this.widgetContentList;

     this.widgetService.SaveWidget(this.pageWidget).subscribe(result => {

       this.pageWidget = new PageWidget();
       this.widgetContentList = [];
       this.router.navigate(["/mobile-page-widget-list"]);
     });
     } else // For Top Vendors
       if (this.currentWidgetTemplateID == 11) {
       // Best Vendors
       this.widgetContent = new WidgetContent();
       this.widgetContentList = [];
       this.widgetContent.type = WidgetContentTypes.BestVendors.toString();
         this.widgetContent.data = "";
         //data structure for saving Top Vendors => commaSepratedIds
         var strVendorIds = "";
         for (var i = 0; i < this.selectedVendorIds.length; i++) {
           strVendorIds += "," + this.selectedVendorIds[i].customerID;
         }
         if (strVendorIds != "") {
           strVendorIds = strVendorIds.substring(1); // remove first comma ','
           this.widgetContent.data = strVendorIds;
         }
       //this.widgetContent.widgetContentID = this.widgetContentTypeVendorId;
       this.widgetContentList.push(this.widgetContent);
       this.pageWidget.dynamicPageID = parseInt(this.customDPage);
       this.pageWidget.widgetTemplateID = this.currentWidgetTemplateID;
       this.pageWidget.widgetContentList = this.widgetContentList;
       this.widgetService.SaveWidget(this.pageWidget).subscribe(result => {

         this.pageWidget = new PageWidget();
         this.widgetContentList = [];
         this.router.navigate(["/mobile-page-widget-list"]);
       });
       } else // For First Level Category
         if (this.currentWidgetTemplateID == 12) {
           this.widgetContent = new WidgetContent();
           this.widgetContentList = [];
           this.widgetContent.type = WidgetContentTypes.FirstLevelCategory.toString();
           this.widgetContent.data = this.selectedCategoryId;
           //this.widgetContent.widgetContentID = this.widgetContentTypeVendorId;
           this.widgetContentList.push(this.widgetContent);
           this.pageWidget.dynamicPageID = parseInt(this.customDPage);
           this.pageWidget.widgetTemplateID = this.currentWidgetTemplateID;
           this.pageWidget.widgetContentList = this.widgetContentList;
           this.widgetService.SaveWidget(this.pageWidget).subscribe(result => {

             this.pageWidget = new PageWidget();
             this.widgetContentList = [];
             this.router.navigate(["/mobile-page-widget-list"]);
           });
         } else // Mobile Banner
             if (this.currentWidgetTemplateID == 15) {
          //save image to server and get its path
          this.widgetService.SaveImage(this.bannerfd).subscribe(
            data => {
              // data structure for image => EnumName:ImageName
              if (data._body != "") {
                let imageName = this.ColonSpliter(data._body);
                this.bannerImageData = this.bannerImageData.replace(WidgetImageContents.DummyPath.toString(), imageName[1]);
              } else if (this.selectedBannerImage != "") {
                this.bannerImageData = this.bannerImageData.replace(WidgetImageContents.DummyPath.toString(), this.selectedBannerImage.split('/')[2]);
              }
              // add new
              this.widgetContent = new WidgetContent();
              this.widgetContentList = [];
             // this.widgetContent.data = this.bannerImageData;
              //new data structure => TextBit~date|url,path
              this.widgetContent.data =  this.isTextOverImage + "~" + this.htmlContent + "|" + this.bannerImageData;
              this.widgetContent.type = WidgetContentTypes.Banner.toString();
              this.widgetContentList.push(this.widgetContent);

              // saving here

              this.pageWidget.dynamicPageID = parseInt(this.customDPage);
              this.pageWidget.widgetTemplateID = this.currentWidgetTemplateID;
              this.pageWidget.widgetContentList = this.widgetContentList;

              //this.pageWidget.id = null; // in case of saving
              this.widgetService.SaveWidget(this.pageWidget).subscribe(result => {

                this.pageWidget = new PageWidget();
                this.widgetContentList = [];
                this.router.navigate(["/mobile-page-widget-list"]);
              });

                 });
             } else
               if (this.currentWidgetTemplateID == 14) {

                 var enumProductWidgetType = this.productWidgetTypes.find(s => s.value == this.productWidgetType);

                 this.widgetContent = new WidgetContent();
                 this.widgetContentList = [];
                 this.widgetContent.type = enumProductWidgetType.title;
                 if (isNaN(this.pageWidget.sortOrder)) {
                   this.pageWidget.sortOrder = 0;
                 }
                 if (enumProductWidgetType.title == WidgetContentTypes.FlashSaleProducts.toString()) {
                   this.widgetContent.data = this.saleId + "|SortOrder:" + this.pageWidget.sortOrder;
                 } else {
                   this.widgetContent.data = "SortOrder:" + this.pageWidget.sortOrder;
                 }
                 this.widgetContentList.push(this.widgetContent);
                 this.pageWidget.dynamicPageID = parseInt(this.customDPage);
                 this.pageWidget.widgetTemplateID = this.currentWidgetTemplateID;
                 this.pageWidget.widgetContentList = this.widgetContentList;
                 this.widgetService.SaveWidget(this.pageWidget).subscribe(result => {

                   this.pageWidget = new PageWidget();
                   this.widgetContentList = [];
                   this.router.navigate(["/mobile-page-widget-list"]);
                 });

               } else // For Top Category
                 if (this.currentWidgetTemplateID == 16) {
                   // Top category
                   this.widgetContent = new WidgetContent();
                   this.widgetContentList = [];
                   //this.widgetContent.widgetContentID = this.widgetContentTypePopularCatId;
                   this.widgetContent.type = WidgetContentTypes.TopCategory.toString();
                   this.widgetContent.data = "";
                   //data structure for saving category Thumbnail => commaSepratedIds
                   var strCategoryIds = "";
                   for (var i = 0; i < this.selectedTopCategoryIds.length; i++) {
                     strCategoryIds += "," + this.selectedTopCategoryIds[i].categoryID;
                   }
                   if (strCategoryIds != "") {
                     strCategoryIds = strCategoryIds.substring(1); // remove first comma ','
                     this.widgetContent.data = strCategoryIds;
                   }
                   this.widgetContentList.push(this.widgetContent);
                   // saving here

                   this.pageWidget.dynamicPageID = parseInt(this.customDPage);
                   this.pageWidget.widgetTemplateID = this.currentWidgetTemplateID;
                   this.pageWidget.widgetContentList = this.widgetContentList;

                   this.widgetService.SaveWidget(this.pageWidget).subscribe(result => {

                     this.pageWidget = new PageWidget();
                     this.widgetContentList = [];
                     this.router.navigate(["/mobile-page-widget-list"]);
                   });
                 } else
                   if (this.currentWidgetTemplateID == 17) {
                     //save image to server and get its path
                     this.widgetService.SaveImage(this.flashSaleBannerfd).subscribe(
                       data => {
                         // data structure for image => EnumName:ImageName
                         if (data._body != "") {
                           let imageName = this.ColonSpliter(data._body);
                           this.flashSaleBannerImageData = this.flashSaleBannerImageData.replace(WidgetImageContents.DummyPath.toString(), imageName[1]);
                         } else if (this.selectedFlashSaleBannerImage != "") {
                           this.flashSaleBannerImageData = this.flashSaleBannerImageData.replace(WidgetImageContents.DummyPath.toString(), this.selectedFlashSaleBannerImage.split('/')[2]);
                         }
                         // add new
                         this.widgetContent = new WidgetContent();
                         this.widgetContentList = [];
                         // this.widgetContent.data = this.bannerImageData;
                         //new data structure => url,path|SaleStartDate,SaleEndDate
                         this.widgetContent.data = this.flashSaleBannerImageData + "|" + this.saleStartDate + "," + this.saleEndDate;
                         this.widgetContent.type = WidgetContentTypes.FlashSaleBanner.toString();
                         this.widgetContentList.push(this.widgetContent);

                         // saving here

                         this.pageWidget.dynamicPageID = parseInt(this.customDPage);
                         this.pageWidget.widgetTemplateID = this.currentWidgetTemplateID;
                         this.pageWidget.widgetContentList = this.widgetContentList;

                         //this.pageWidget.id = null; // in case of saving
                         this.widgetService.SaveWidget(this.pageWidget).subscribe(result => {

                           this.pageWidget = new PageWidget();
                           this.widgetContentList = [];
                           this.router.navigate(["/mobile-page-widget-list"]);
                         });

                       });
                   } else
                     if (this.currentWidgetTemplateID == 18) {
                       //save image to server and get its path
                       this.widgetService.SaveImage(this.bannerfd).subscribe(
                         data => {
                           // data structure for image => EnumName:ImageName
                           if (data._body != "") {
                             let imageName = this.ColonSpliter(data._body);
                             // add new
                             this.widgetContent = new WidgetContent();
                             this.widgetContentList = [];
                             //this.widgetContent.widgetContentID = this.bannerWidgetContentId;
                             this.widgetContent.data = imageName[1];
                             this.widgetContent.type = WidgetContentTypes.ILoveAppBanner.toString();
                             this.widgetContentList.push(this.widgetContent);

                             // saving here
                             this.pageWidget.dynamicPageID = parseInt(this.customDPage);
                             this.pageWidget.widgetTemplateID = this.currentWidgetTemplateID;
                             this.pageWidget.widgetContentList = this.widgetContentList;

                             //this.pageWidget.id = null; // in case of saving
                             this.widgetService.SaveWidget(this.pageWidget).subscribe(result => {

                               this.pageWidget = new PageWidget();
                               this.widgetContentList = [];
                               this.router.navigate(["/mobile-page-widget-list"]);
                             });
                           }
                         });
                     }
    this.toastr.success('Widget Saved successfully.', 'Success');
  }

  enumSelector(enumName) {
    return Object.keys(enumName)
      .map(key => ({ value: key, title: enumName[key] }));
  }

  WidgetContentInitialization() {
    this.thumbnailCategoryList = [];
    this.pageWidget = new PageWidget();
    this.widgetContentList = [];
    this.selectedPopualarCategoryIds = [];
    this.popularCategoryList = [];
    this.widgetContentTypePopularCatId = 0;
    this.bannerfd = new FormData();
    this.selectedBannerImage = "";
    this.bannerImageRedirectUrl = "";
    this.flashSaleBannerfd = new FormData();
    this.selectedFlashSaleBannerImage = "";
    this.flashSaleBannerImageRedirectUrl = "";
    this.productWidgetType = "";
    this.productWidgetTypeId = 0;
    this.savedPageWidgetId = 0;
    this.saleId = 0;
    this.selectedILoveAppBannerImage = "";
  }

  ColonSpliter(str: string): string[] {
    return str != "" ? str.toString().split(':') : [];
  }



}
enum WidgetContentTypes {
  
  PopularCategory = "Popular Category",
  PopularBrands = "Popular Brands",
  Banner = "Banner",
  BestVendors = "Best Vendors",
  FirstLevelCategory = "First Level Category",
  TopSellingProducts = "Top Selling Products",
  RecentProducts = "Recent Products",
  FeaturedProducts = "Featured Products",
  OnsaleProducts = "Onsale Products",
  TopRatedProducts = "Top Rated Products",
  FlashSaleProducts = "Flash Sale Products",
  JustForYou = "Just For You",
  TopCategory = "Top Category",
  FlashSaleBanner = "Flash Sale Banner",
  ILoveAppBanner = "I Love App Banner",
}
enum ProductWidgetTypes {
  TopSellingProducts = "Top Selling Products",
  //RecentProducts = "Recent Products",
  //FeaturedProducts = "Featured Products",
  //OnsaleProducts = "Onsale Products",
  //TopRatedProducts = "Top Rated Products",
  FlashSaleProducts = "Flash Sale Products",
  JustForYou = "Just For You",
}
enum WidgetImageContents {
  DummyPath = "DummyPath",
}



// WEBPACK FOOTER //
// ./src/app/widget-mobile/create-mobile-page-widget/create-mobile-page-widget.component.ts